export const getResponseBody = ( response: any ) => ( response?.data ?? response ?? null );

/** Payload útil dentro de response.data (apisauce / API .NET) */
export const extractApiPayload = ( response: any ) => {
  if ( !response ) return {};
  return response.data?.data ?? response.data ?? {};
};

export const runIdFromApiResponse = ( response: any ): string | null => {
  const payload = extractApiPayload( response );
  const id = payload.runId ?? payload.RunId;
  if ( id == null || id === '' ) return null;
  return String( id );
};

export const statusFromApiResponse = ( response: any ): string => {
  const payload = extractApiPayload( response );
  return String( payload.status ?? payload.Status ?? '' ).toUpperCase();
};

export const isNeverSyncedNotFound = ( response: any ) => response?.status === 404;

const TERMINAL = new Set( [
  'COMPLETED',
  'COMPLETED_WITH_ERRORS',
  'FAILED',
] );

export const isTerminalSyncStatus = ( status: string ) => TERMINAL.has( status );

export const getStatusValue = ( body: any ) => {
  const payload = body?.data ?? body;
  return String( payload?.status ?? body?.status ?? '' ).toUpperCase();
};

export const getFieldValue = ( body:any, key:string ) => {
  const payload = body?.data ?? body;
  if ( payload?.[key] != null ) return payload[key];
  return body?.[key];
};

export const stringifySafe = ( value:any ) => {
  if ( value == null ) return '';
  if ( typeof value === 'string' ) return value;
  try {
    return JSON.stringify( value, null, 2 );
  } catch {
    return String( value );
  }
};

export const getLogsList = ( body:any ) => {
  const payload = body?.data ?? body;
  if ( Array.isArray( payload ) ) return payload;
  if ( Array.isArray( payload?.items ) ) return payload.items;
  if ( Array.isArray( payload?.events ) ) return payload.events;
  if ( Array.isArray( payload?.logs ) ) return payload.logs;
  return [];
};
